<script>
import ValidateMixin from './mixins/validate'
import dayjs from 'dayjs'

export default {
  name: 'RnrDatePicker',
  mixins: [ValidateMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    attrs: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    minDate: {
      type: Object,
      default: new Date(1900, 1, 1)
    },
    maxDate: {
      type: Object,
      default: new Date(2999, 12, 30)
    },
    validateCallback: {
      type: Function,
      default: null
    },
    valueDisplay: {
      type: Function,
      default: date => {
        // 如果当前没有传入日期
        if (!date) {
          return null
        }
        return dayjs(date).isValid() ? dayjs(date).format('YYYY-MM-DD') : date
      }
    },
    valueFormatter: {
      type: Function,
      default: date => {
        return dayjs(date).valueOf()
      }
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    /**
     * 数据改变方法
     */
    handleConfirm(value) {
      // 开始双向绑定数据
      this.$emit('input', this.valueFormatter(value))
      this.$emit('change', this.valueFormatter(value))
      // 关闭弹出框
      this.visible = false
      // 等页面渲染完成后开始校验数据
      this.$nextTick(this.validate)
    },

    /**
     * 点击关闭方法
     */
    handleCancel() {
      // 开始校验数据
      this.validate()
      // 通知父组件关闭事件
      this.$emit('close')
      // 关闭数据
      this.visible = false
    }
  },
  render() {
    return (
      <div class='date-picker'>
        <van-field
          value={this.valueDisplay(this.value)}
          clearable={true}
          required={this.required}
          clear-trigger='always'
          clickable
          is-link
          label={this.label}
          readonly
          placeholder='请选择'
          input-align='right'
          onClick={() => (this.visible = true)}
        />
        <van-popup value={this.visible} onInput={visible => (this.visible = visible)} round position='bottom'>
          <van-datetime-picker
            minDate={this.minDate}
            maxDate={this.maxDate}
            type='date'
            title='选择年月日'
            onCancel={this.handleCancel}
            onConfirm={this.handleConfirm}
          />
        </van-popup>
      </div>
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormRender/date-picker.vue